module.exports = __webpack_public_path__ + "static/media/Camera01.d12a2b99.jpg";